import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import Button from '@mui/material/Button';

type ParamsStyle = {
    theme?: Theme;
}
export const Container = styled('li')(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        position: relative;
        border-radius: 6px;
        min-height: 21.625rem;
        padding: 1.46rem 1.3rem;
        border: 1.5px solid #008DD2;

        .btn-copy {
            min-height: 1.5rem;
            min-width: 1.125rem;
            border: none;
            cursor: pointer;
            background-color: transparent;

            svg {
                width: 100%;
                height: 100%;
            }
        }

        li {
            display: flex;
            gap: .5rem;
            align-items: center;
            padding-top: 1.31rem;

            input {
                width: 1rem;
                height: 1rem;
                accent-color: ${theme?.palette.primary.main};
            }

            label {
                font-size: .875rem;
                padding-top: .125rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            p {
                overflow: hidden;
                max-height: 40px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
            }
        }
`);

export const RiskGreen = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        margin: .5rem 0;
        align-items: end;

        div {
            width: 7.5rem;
            height: .2rem;
            background-color: ${theme?.palette.secondary.main};
        }

        span {
            height: 1px;
            width: 100%;
            display: block;
            background-color: #ECECEC;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            div {
                width: 3.5rem;
            }
            span {
                width: 7.8rem;
            }
        }
`);
export const ContentTimesBtn = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        align-items: start;
        flex-direction: column;
        justify-content: space-between;
        gap: 1.5rem;

        button {
            width: 100%;
            max-width: 100%;
        }

        .box-hours {
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;

            li {
                gap: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                label {
                    cursor: pointer;
                    padding-left: .5rem;
                }
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            .box-hours {
                grid-template-columns: 1fr 1fr;
            }
            
            button {
                max-width: 100%;
            }
        }
`);
export const ContentGrid = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: grid;
        padding-top: .6rem;
        grid-template-columns: 30% 70%;
        grid-template-areas:
		    "distance address"
		    "risk risk"
            ;

        .address {
            display: flex;
            padding: 0 0 0 1rem;

            svg {
                width: 25px;
                height: auto;
                margin: -2px 0 0 2px;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding: 0;
            grid-template-columns: 1fr;
            grid-template-areas:
		    "distance"
		    "risk"
            "address"
            ;

            .address {
                padding: .75rem 0 0 0;
            }
        }
`);

export const ContentBox = styled('div')(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        padding: 0 0 1.75rem;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        p {
            padding: 0;
            font-size: 1.125rem;

            &.frustrated-text {
                line-height: 15px;
                font-size: .75rem;
            }
        }

        &.box-btn {
            padding: 0;

            button {
                width: 100%;
            }
        }


        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding: 0 0 1.375rem;

            &.box-btn {
                padding: 0;
            }

            p {
                font-size: 1.25rem;
            }   
        }
`);


export const ContainerModal = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        width: calc(100vw - 2rem);
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 2.75rem 2.125rem;

        p {
            line-height: 1;
        }

        nav {
            width: 100%;
            height: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 40px;
            margin-bottom: 1.5rem;
            background-color: ${theme?.palette.primary.light};

            p {
                color: #ffffff;
                line-height: 1;
                font-size: 1.125rem;
                padding-top: .3rem;
            }
        }
        
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            max-width: 30rem;

            nav {
                p {
                    font-size: 1.5rem;
                }
            }   
        }
`);

export const Card = styled('div')(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        min-height: 2.18rem;
        padding: .2rem 2.25rem 0;
        border-radius: 7px;
        border: 1.5px solid #008DD2;

        p {
            font-size: 1.125rem;
        }

        .address {
            display: flex;
            flex-direction: column;
            gap: .3rem;
            padding: 1rem 0;

            .title {
                font-size: 1.25rem;
            }

            button {
                border: none;
                cursor: pointer;
                background-color: transparent;
            }

            p {
                font-size: .9rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
    
        }
`);

export const ButtonCancel = styled(Button)(
    ({ theme }: ParamsStyle) => `
        height: 2.81rem;
        font-weight: 700;
        border-radius: 5px;
        margin-top: .68rem;
        border: 1.5px solid ${theme?.palette.primary.main};
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);